import React, { useReducer } from "react";
import destMarketReducer, {
  destMarketInitialState
} from "./reducers/dest-market-reducer";

const DestMarketContext = React.createContext();

function useDestMarket() {
  const context = React.useContext(DestMarketContext);
  if (!context) {
    throw new Error(`useCount must be used within a DestMarketProvider`);
  }
  return context;
}

function DestMarketProvider(props) {
  const [destMarketState, destMarketDispatch] = useReducer(
    destMarketReducer,
    destMarketInitialState
  );
  const value = React.useMemo(() => [destMarketState, destMarketDispatch], [
    destMarketState
  ]);

  return <DestMarketContext.Provider value={value} {...props} />;
}

export { DestMarketProvider, useDestMarket };
